import React from 'react';
import angular from 'angular';
import { render, unmountComponentAtNode } from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../store';

export default ({
  Component = null,
  directiveName = '',
  attachToBody = false,
  element = null,
  withProvider = false,
  replace,
  dynamicTemplate,
  template,
  watch,
}) => {
  const reactAngularDirective = () => ({
    restrict: 'E',
    replace: replace || 'true',
    scope: {
      props: '<',
    },
    template: dynamicTemplate ? dynamicTemplate(store) : template,
    link: (scope, directiveElement) => {
      const { props = {} } = scope;
      let elementToRenderTo = directiveElement[0];

      if (attachToBody) {
        const bodyElement = document.createElement('span');
        elementToRenderTo = document.body.appendChild(bodyElement);
      }

      if (element) elementToRenderTo = element;

      const componentJSX = <Component {...props} />;

      if (withProvider) {
        render(<Provider store={store}>{componentJSX}</Provider>, elementToRenderTo);
      } else {
        render(componentJSX, elementToRenderTo);
      }

      if (watch) {
        scope.$watch(
          'props',
          (newProps) => {
            render(
              <Provider store={store}>
                <Component {...newProps} />
              </Provider>,
              elementToRenderTo,
            );
          },
          true,
        );
        scope.$on('$destroy', () => {
          unmountComponentAtNode(elementToRenderTo);
        });
      }
    },
  });

  angular.module('narvarReturns').directive(directiveName, [reactAngularDirective]);

  return reactAngularDirective;
};
